angular.module('iw.frontyard.translate')
    .directive('iwTranslate', function (Translator, StringHelper) {

        return {
            restrict: 'A',
            scope: {
                interpolate: '=',
                pluralize: '=',
                context: '@',
            },
            link: function ($scope, element, attributes) {
                var textToTranslate = getTextToTranslate();
                var translation = Translator.translate(textToTranslate);

                if (angular.isDefined($scope.interpolate)) {
                    translation = Translator.interpolate(translation, $scope.interpolate, true);
                }

                if (angular.isDefined($scope.pluralize)) {
                    translation = Translator.pluralize(textToTranslate, attributes.plural, $scope.pluralize);
                }

                if (angular.isDefined($scope.context)) {
                    translation = Translator.translateAs(textToTranslate, $scope.context);
                }

                element.text(translation);

                $scope.$watch('pluralize', function (newValue, oldValue) {
                    if (newValue) {
                        var pluralized = Translator.pluralize(textToTranslate, attributes.plural, newValue);
                        element.text(pluralized);
                    }
                });

                function getTextToTranslate() {
                    if (attributes.disableTrim !== 'true') {
                        return StringHelper.trim(getElementContent());
                    }

                    return getElementContent();
                }

                function getElementContent() {
                    if (angular.isDefined(attributes.keepHtml)) {
                        return element.html();
                    }

                    return element.text();
                }
            }
        };
    });
